import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Box from '../../../../shared/Box';
import Pressable from '../../../../shared/Pressable';
import Text from '../../../../shared/Text/index.tsx';
import { RichTextEditor } from './components/RichTextEditor';

import styles from './styles.sass';

const cx = classnames.bind(styles);

const FieldRichTextEditor = ({
  input: { name, onBlur, onChange, onFocus, value },
  meta: { error, valid, submitFailed },
  type,
  label,
  placeholder,
  maxCharacterLength,
  isRichTextEditor,
  onPressEditorModeToggle,
  toggleFocusStyles,
  isShowingFocusStyles,
}) => {
  const isShowingError = submitFailed && !valid;
  return (
    <Box width="100%">
      <label className={styles.label} htmlFor={name}>
        <div className={styles.headerContainer}>
          <Text color="#292f36" size="lg">
            {label}
          </Text>
          <div className={styles.toggleWrapper}>
            <button
              onClick={onPressEditorModeToggle}
              type="button"
              className={styles.modeToggleText}
            >
              {isRichTextEditor ? 'Switch to HTML' : 'Switch to rich text'}
            </button>
          </div>
        </div>
        {isRichTextEditor ? (
          <div
            className={cx({
              textEditorWrapper: true,
              inputError: isShowingError,
              focused: isShowingFocusStyles,
            })}
          >
            <RichTextEditor
              name={name}
              maxCharacterLength={maxCharacterLength}
              onBlur={e => {
                onBlur(e);
                toggleFocusStyles();
              }}
              onFocus={() => {
                onFocus();
                toggleFocusStyles();
              }}
              onChange={onChange}
              placeholder={placeholder}
              value={value}
              type={type}
            />
          </div>
        ) : (
          <textarea
            className={styles.textarea}
            rows={15}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            placeholder="<p></p>"
            value={value}
            type={type}
          />
        )}
      </label>
      <Box display="flex" justifyContent="between">
        <div
          className={cx({
            errorText: true,
            errorTextVisible: isShowingError,
          })}
        >
          <Text color="#d0021b">{error}</Text>
        </div>
        {maxCharacterLength && (
          <Text size="sm" color="#7f8287">
            {`${value.length} / ${maxCharacterLength}`}
          </Text>
        )}
      </Box>
    </Box>
  );
};

FieldRichTextEditor.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onDragStart: PropTypes.func,
    onDrop: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    active: PropTypes.bool,
    asyncValidating: PropTypes.bool,
    autofilled: PropTypes.bool,
    dirty: PropTypes.bool,
    dispatch: PropTypes.func,
    form: PropTypes.string,
    initial: PropTypes.string,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitFailed: PropTypes.bool,
    submitting: PropTypes.bool,
    touched: PropTypes.bool,
    valid: PropTypes.bool,
    visited: PropTypes.bool,
  }).isRequired,
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  maxCharacterLength: PropTypes.number.isRequired,
  isRichTextEditor: PropTypes.bool.isRequired,
  onPressEditorModeToggle: PropTypes.func.isRequired,
  toggleFocusStyles: PropTypes.func.isRequired,
  isShowingFocusStyles: PropTypes.bool.isRequired,
};
export { FieldRichTextEditor };
